import axios from "axios";
import React, { useEffect, useState } from "react";
import DisplayExcel from "./DisplayExcel";
import { getCookie } from "../../services/DataRequestService";
import { displayMessage } from "../../Utils/helper";
import AuthService from "../../services/AuthService";


const { REACT_APP_API_BASE_URL } = process.env

const UploadFile = () => {

    const [workflows, setWorkflows] = useState([])
    const [selectedWorkflow, setSelectedWorkflow] = useState("");
    const [selectedWorkflowID, setSelectedWorkflowID] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [showTable, setShowTable] = useState(false); // State to toggle the DisplayExcel component



    useEffect(() => {
        getWorkflows()
    }, [])

    const getWorkflows = async () => {
        try {
            // Construct the full URL by directly appending the query parameter
            // const url = `${REACT_APP_API_BASE_URL}/weekly_workflow_data?workflow_id=${workflow.workflow_id}`;
            const url = `${REACT_APP_API_BASE_URL}/get_wf_for_sp?user_id=${getCookie("sub")}`;
            // 
            // Perform the GET request
            const response = await axios.get(url, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization" : AuthService.getAccessToken(),
                    "access_token" : AuthService.getAccessToken()
                    // access_token: UserService.getToken(), // Replace with your token retrieval function
                },
            });

            // Handle the response
            console.log(response.data.data);
            setWorkflows(response.data.data);
            setSelectedWorkflowID(response.data.data[0].workflow_id)


        } catch (error) {
            // Handle errors
            console.error("Error fetching workflows:", error.message);
            throw error;
        }
    }



    // Handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
        setShowTable(true);
    };

    // Handle form submission
    const handleSubmit = async () => {
        console.log(selectedWorkflow);
        console.log(selectedFile);

        try {
            // if (!selectedWorkflow || !selectedFile) {
            if (!selectedFile) {
                alert("Please select a workflow and a file!");
                return;
            }

            const url = `${REACT_APP_API_BASE_URL}/upload_forecast?user_id=${getCookie("sub")}&workflow_id=${selectedWorkflowID}`;

            // Create a FormData object
            const formData = new FormData();
            formData.append("file", selectedFile);

            // Perform the POST request
            const response = await axios.post(url, formData, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                    "Authorization" : AuthService.getAccessToken(),
                    "access_token" : AuthService.getAccessToken()
                    // access_token: UserService.getToken(), // Replace with your token retrieval function
                },
            })
            console.log(response);

            if (response.status == "200") displayMessage('success', response.data.message, '');
            else displayMessage('danger', response.data.message, '');

        } catch (error) {
            console.error("Error uploading file:", error);
            alert("An error occurred while uploading the file.");
        }
        // Show the DisplayExcel component when the button is clicked
    };

    return (
        <>
            <h2 style={{ margin: "5vh 0 5vh 0" }} className="text-3xl font-bold mb-4 text-center">Upload Data</h2>
            <div className="p-6 bg-gradient-to-r rounded-lg shadow-md mycontainer manage-workflow-box">
                <div className="flex flex-col md:flex-row gap-6 items-center">
                    {/* Workflow Dropdown */}
                    <div className="flex-1 w-full">
                        <label className="block text-gray-700 font-medium mb-2" htmlFor="workflow">
                            Select Workflow:
                        </label>
                        <select
                            id="workflow"
                            className="w-full border rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0C3C54]"
                            // value={selectedWorkflow}
                            onChange={(e) => {
                                // setSelectedWorkflow(e.target.value);
                                const selectedWorkflow = workflows.find(
                                    (workflow) => workflow.workflow_name === e.target.value
                                );
                                if (selectedWorkflow) {
                                    console.log(selectedWorkflow.workflow_id);
                                    setSelectedWorkflowID(selectedWorkflow.workflow_id);
                                }
                            }}
                        >
                            {workflows.map((workflow, index) => (
                                <option key={index} value={workflow.workflow_name}>
                                    {workflow.workflow_name}
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* File Input */}
                    <div className="flex-1 w-full">
                        <label className="block text-gray-700 font-medium mb-2" htmlFor="file">
                            Select File:
                        </label>
                        <input
                            type="file"
                            id="file"
                            accept=".xlsx, .xls"
                            className="w-full border rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0C3C54]"
                            onChange={handleFileChange}
                        />
                    </div>

                    {/* Submit Button */}
                    <div className="flex-none relative top-6">
                        <button
                            onClick={handleSubmit}
                            className="bg-[#0C3C54] hover:bg-[#0C3A65] text-white font-medium px-6 py-2 rounded-lg transition-all duration-200 shadow-md"
                        >
                            Upload
                        </button>
                    </div>
                </div>
                {/* DisplayExcel Component */}
                {showTable && (
                    <div className="mt-8">
                        <DisplayExcel file={selectedFile} /> {/* Pass the file as a prop */}
                    </div>
                )}
            </div>
        </>
    );
};

export default UploadFile;
